import { VIEWS, type ViewId } from '@ouradent/shared';

// Screens not built yet keep their real heading, so the nav, the routes and the
// role-based E2E tests stay exercised, and say plainly what is coming.
const NEXT: Partial<Record<ViewId, string>> = {};

export function Placeholder({ view }: { view: ViewId }) {
  const meta = VIEWS.find((v) => v.id === view);

  return (
    <>
      <header className="mb-8 flex flex-wrap items-center justify-between gap-5">
        <div>
          <h1 className="text-[34px] font-bold leading-[1.05] tracking-[-0.035em] md:text-[44px]">
            {meta?.label}
          </h1>
          <p className="mt-1.5 text-lg text-muted">Not built yet.</p>
        </div>
      </header>

      <section className="card p-7" data-testid={`view-${view}`}>
        <p className="text-muted">{NEXT[view] ?? 'This screen is not built yet.'}</p>
      </section>
    </>
  );
}
